module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.2372/img/callout-wave.svg"